import { TextFading } from '@yes.technology/react-toolkit'
import InformationalFadingContainer from 'site/Renderer/components/InformationalFadingContainer/InformationalFadingContainer'
import { SafeHtmlContent } from 'site/shared/components/SafeHtmlContent'
import {
  ActionSlot,
  Container,
  Label,
  LabelRow,
  ValueArea
} from './InformationalHtmlField.styles'

type InformationalHtmlFieldProps = {
  label: string
  html: string
  actionButton?: React.ReactNode
  maxHeight?: string
  enableLabelFading?: boolean
}

const InformationalHtmlField = ({
  label,
  html,
  actionButton,
  maxHeight = '100px',
  enableLabelFading = true
}: InformationalHtmlFieldProps) => (
  <Container $hasAction={!!actionButton}>
    <LabelRow $hasAction={!!actionButton}>
      <Label>
        {enableLabelFading ? <TextFading>{label}</TextFading> : label}
      </Label>
      {actionButton && <ActionSlot>{actionButton}</ActionSlot>}
    </LabelRow>
    <ValueArea data-testid='informational-value'>
      <InformationalFadingContainer maxHeight={maxHeight}>
        <SafeHtmlContent html={html} />
      </InformationalFadingContainer>
    </ValueArea>
  </Container>
)

export default InformationalHtmlField
